// ProtectedRoute.jsx
import { useUser } from "../context/UserContext";
import { can } from "./access";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

/**
 * Protects a route based on:
 * 1. User is logged in
 * 2. User has the required permission (optional)
 *
 * @param {ReactNode} children - The component to render
 * @param {string} permission - Optional permission to check
 * @param {ReactNode} fallback - Optional component to render if no permission
 */
export default function ProtectedRoute({ children, permission, fallback = null }) {
  const { localUser, loading } = useUser();
  const location = useLocation();

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  // Not logged in → redirect to login
  if (!localUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Logged in but missing permission → redirect or show fallback
  if (permission && !can(localUser, permission)) {
    return fallback || <Navigate to="/profile" replace />;
  }

  // Allowed → render the children
  return children;
}
